import PropTypes from "prop-types";
import React, {Component} from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import {withRouter} from "react-router-dom";
import {Link} from "react-router-dom";
import {withTranslation} from "react-i18next";
import {havePermission} from "../../common/general";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              {havePermission(4) && <React.Fragment>
                <li className="menu-title">{this.props.t("Client")}</li>

                <li>
                  <Link to="/simple-inbox" className="">
                    <i className="bx bx-box"/>
                    <span>{this.props.t("Inbox")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/simple-files" className="">
                    <i className="bx bx-file-blank"/>
                    <span>{this.props.t("Files")}</span>
                  </Link>
                </li>
              </React.Fragment>}

              {havePermission(3) && <React.Fragment>
                <li className="menu-title">{this.props.t("Staff")}</li>

                {havePermission(20) && <li>
                  <Link to="/inbox" className="">
                    <i className="bx bxs-inbox"/>
                    <span>{this.props.t("Inbox")}</span>
                  </Link>
                </li>}

                {havePermission(21) && <li>
                  <Link to="/files" className="">
                    <i className="bx bx-file"/>
                    <span>{this.props.t("Files")}</span>
                  </Link>
                </li>}

                {havePermission(22) && <li>
                  <Link to="/search" className="">
                    <i className="bx bx-search-alt"/>
                    <span>{this.props.t("Search")}</span>
                  </Link>
                </li>}
              </React.Fragment>}

              {havePermission(2) && <React.Fragment>
                <li className="menu-title">{this.props.t("Manager")}</li>

                <li>
                  <Link to="/dashboard" className="">
                    <i className="bx bxs-dashboard"/>
                    <span>{this.props.t("Dashboard")}</span>
                  </Link>
                </li>
              </React.Fragment>}

              {havePermission(1) && <React.Fragment>
                <li className="menu-title">{this.props.t("Admin")}</li>

                <li>
                  <Link to="/companies" className="">
                    <i className="bx bx-buildings"/>
                    <span>{this.props.t("Companies")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/sections" className="">
                    <i className="bx bx-cloud"/>
                    <span>{this.props.t("Sections")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/segments" className="">
                    <i className="bx bx-data"/>
                    <span>{this.props.t("Segments")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/users" className="">
                    <i className="bx bx-user"/>
                    <span>{this.props.t("Users")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/groups" className="">
                    <i className="bx bx-group"/>
                    <span>{this.props.t("Groups")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/notifications" className="">
                    <i className="bx bx-notification"/>
                    <span>{this.props.t("Notifications")}</span>
                  </Link>
                </li>

                <li className="menu-title">{this.props.t("System")}</li>

                <li>
                  <Link to="/#">
                    <i className="bx bx-store-alt"/>
                    <span>{this.props.t("Enums")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/enums/permissions">{this.props.t("Permissions")}</Link>
                    </li>
                    <li>
                      <Link to="/enums/versions">{this.props.t("Versions")}</Link>
                    </li>
                    <li>
                      <Link to="/enums/storages">{this.props.t("Storages")}</Link>
                    </li>
                  </ul>
                </li>
              </React.Fragment>}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));